import Divider from "antd/lib/divider";
import Skeleton from "antd/lib/skeleton";

export const DefaultSkeleton = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <div {...props} className="flex size-full flex-col p-4 select-none">
        <Skeleton.Input active size="large" className="mb-0! h-8! w-3/4!" />
        <div className="my-ant-sm">
            <div className="relative">
                <Skeleton.Button active size="large" className="mb-1! h-2! w-full!" />
            </div>
            <Skeleton.Input active size="small" className="mt-1! ml-auto! h-3! w-1/3!" />
        </div>
        <Divider />
        <div className="my-ant-sm text-center">
            <Skeleton.Button active size="small" className="h-8! w-32!" />
        </div>
    </div>
);
